import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { date, FormCollectorDirective, ModalBase, template } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { User } from '@task-modules/users';

 type hoursIn =  {
    planned_start_time: Date | null,
    planned_end_time: Date | null,
}

@Component({
    selector: 'task-add-working-hours-dialog',
    template: `
    <div class="flex-column fullheight-noscroll">
        <h2 class="modal-title">
            {{ 'PLAN_WORKING_HOURS' | trans }}
        </h2>
        <div style="overflow: auto">
            <div class="field-grid" form-collector #addWorkingHoursForm="collector">
                <task-date-picker-input class="flex-dynamic input outlined" 
                    [classes]="'flex-dynamic input outlined whole-row'"
                    [required]="true" 
                    [label]="'DATE' | trans" 
                    [(ngModel)]="for_date"
                    [min-date]="min_date"
                    [max-date]="injectedData.end_date"
                ></task-date-picker-input>

                <task-time-picker-input class="flex-dynamic input outlined" 
                    [classes]="'flex-dynamic input outlined'"
                    [required]="true" [label]="'PLANNED_START' | trans" 
                    [(ngModel)]="hours.planned_start_time">
                </task-time-picker-input>

               <task-time-picker-input class="flex-dynamic input outlined" 
                    [classes]="'flex-dynamic input outlined'"
                    [required]="true" [label]="'PLANNED_END' | trans" 
                    [(ngModel)]="hours.planned_end_time">
                </task-time-picker-input>
            </div>
        </div>

        <div class="flex-row modal-footer">
            <button color="primary"
                    (click)="cancel()">
                <i icon="clear"></i>
                <span>{{ 'CANCEL' | trans }}</span>
            </button>

            <button class="filled"
                    color="secondary"
                    (click)="done()"
                    [disabled]="addWorkingHoursForm.containsErrors()">
                <i icon="check"></i>
                <span>{{ 'SAVE' | trans }}</span>
            </button>

        </div>
    </div>
    `,

})
    export class AddWorkingHoursDialog extends ModalBase<{
        start_date: Date,
        end_date: Date,
        application_id: number
    }, boolean> implements OnInit {
    @ViewChild('addWorkingHoursForm')
    addWorkingHoursForm: FormCollectorDirective;
    
    preventSoftClose = true;

    get application_id() {
        return this.injectedData.application_id;
    }
    
    get min_date() {
        let first = max_date(this.injectedData.start_date, date.today());
        return min_date(first, this.injectedData.end_date);
    }

    get max_date() {
        return this.injectedData.end_date;
    }   

    hours: hoursIn = { 
        planned_start_time: new Date(2026, 3, 3, 8, 0, 0),
        planned_end_time: new Date(2026, 3, 3, 16, 0, 0),
    }
    for_date = new Date();


    user: User.Current;
    is_admin = false;
    
    
    async get_user() {
        this.user = await User.currentUserPromise;
        this.is_admin = this.user.user_type_id == Task.USER_TYPE.ADMIN || 
            this.user.user_type_id == Task.USER_TYPE.SYSTEM_ADMIN;
    }

   
    cancel() {
		this.submit(false);
	}

    done() {
        let date_part = this.for_date.toISOString().split("T")[0];
        let start_part = this.hours.planned_start_time.toISOString().split("T")[1];
        let end_part = this.hours.planned_end_time.toISOString().split("T")[1];

        let hours = {
            planned_start_time: date_part + "T" + start_part,
            planned_end_time: date_part + "T" + end_part,
        }

        TaskRoutes.temp_staff_requests.api_temp_staff_plan_add(this.application_id, hours).then(() => {
            this.submit(true);
        })
    }


    ngOnInit(): void {
        this.for_date = this.min_date;
        this.get_user();
    }
}

function min_date(d1: Date, d2: Date) {
    if (d1 < d2) {
        return d1;
    }
    return d2;
}

function max_date(d1: Date, d2: Date) {
    if (d1 > d2) {
        return d1;
    }
    return d2;
}

